import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { findIndex } from 'lodash';
import { Button } from 'ui';
import Tooltip from 'components/shared/Tooltip';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import AnswersContainer from './AnswersContainer';

const LessonsToGradeSection = props => {
  const { progress = {}, markProgressGraded, ziggeoApiKey = '' } = props;
  const { answers: initialAnswers } = progress;
  const [answers, setAnswers] = useState(initialAnswers);
  const [saving, setSaving] = useState(false);

  const submitAnswers = () => {
    setSaving(true);

    const updatedAnswers = answers.reduce((updated, answer) => {
      return {
        ...updated,
        [answer.id]: {
          correct: answer.correct !== null ? String(answer.correct) : null,
          feedback: answer.feedback,
          feedback_criteria_ratings_attributes: answer.criteriaRatings.map(
            ({ id, score }) => ({ id, score }),
          ),
        },
      };
    }, {});
    request
      .put(routes.GRADES.UPDATE(progress.id), {
        answers: updatedAnswers,
      })
      .then(data => {
        setSaving(false);
        if (data.success) {
          pubsub.publish('grades:update_pending_count');
          if (data.progressGraded) {
            markProgressGraded();
          }
        }
      });
  };

  const setGradedAnswers = answerId => (correct, feedback, criteriaRatings) => {
    const newGradedAnswers = [...answers];
    const answer = answers.find(ans => ans.id === answerId);
    const gradedAnswer = {
      ...answer,
      isGraded: correct === 'true' || correct === 'false',
    };
    if (correct !== null) gradedAnswer.correct = correct;
    if (feedback !== null) gradedAnswer.feedback = feedback;
    if (criteriaRatings !== null) {
      gradedAnswer.criteriaRatings = criteriaRatings;
    }
    if (newGradedAnswers.length === 0) {
      newGradedAnswers.push(gradedAnswer);
    } else {
      const answerIndex = findIndex(answers, ans => ans.id === answerId);
      newGradedAnswers[answerIndex] = gradedAnswer;
    }
    setAnswers(newGradedAnswers);
  };

  const hasGradedAnswers =
    answers && answers.filter(answer => answer.isGraded).length > 0;
  const nonPracticeAnswers =
    answers && answers.filter(answer => !answer.isPracticeQuestion);
  const practiceAnswers =
    answers && answers.filter(answer => answer.isPracticeQuestion);

  return (
    <>
      <>
        {nonPracticeAnswers.length > 0 && (
          <AnswersContainer
            answers={nonPracticeAnswers}
            currentUser={progress.userName}
            setGradedAnswers={setGradedAnswers}
            ziggeoApiKey={ziggeoApiKey}
          />
        )}
        {practiceAnswers.length > 0 && (
          <AnswersContainer
            answers={practiceAnswers}
            currentUser={progress.userName}
            practiceQuestionAnswers
            setGradedAnswers={setGradedAnswers}
            ziggeoApiKey={ziggeoApiKey}
          />
        )}
      </>
      <div className="d-f jc-e mt-16">
        <Tooltip
          text={!hasGradedAnswers && t('grades.disabled_submit')}
          align="end"
        >
          <Button
            type="button"
            customColor
            onClick={submitAnswers}
            disabled={!hasGradedAnswers || saving}
          >
            {saving ? t('common.notify_saving') : t('grades.submit')}
          </Button>
        </Tooltip>
      </div>
    </>
  );
};

LessonsToGradeSection.propTypes = {
  progress: PropTypes.shape({
    id: PropTypes.number,
    userName: PropTypes.string,
    lessonName: PropTypes.string,
    daysAwaitingGrade: PropTypes.number,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        correct: PropTypes.bool,
        feedback: PropTypes.string,
        isGraded: PropTypes.bool,
        isPracticeQuestion: PropTypes.bool,
        criteriaRatings: PropTypes.arrayOf(
          PropTypes.shape({ id: PropTypes.number, score: PropTypes.number }),
        ),
      }),
    ),
  }),
  markProgressGraded: PropTypes.func,
  ziggeoApiKey: PropTypes.string,
};

export default LessonsToGradeSection;
